import React from "react";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/input";
import { ClearButton } from "@/components/ui/ClearButton";
import type { RowState } from "@/components/advanceSearch/types";

interface Props {
  row: RowState;
  control: any;
  onClear: (which: "value" | "value2") => void;
}

export const ConditionTextInput: React.FC<Props> = ({ row, control, onClear }) => (
  <FormField
    control={control}
    name={`value_${row.id}` as const}
    rules={{ required: "This field is required." }}
    render={({ field }) => {
      const handleClear = () => {
        field.onChange("");
        onClear("value");
      };

      return (
        <FormItem className="relative">
          <FormControl>
            <Input
              {...field}
              value={field.value ?? ""}
              autoComplete="off"
              inputMode="text"
              className="w-full h-9  rounded-md bg-white pr-8 text-sm text-gray-700 shadow-none focus-visible:ring-0 focus-visible:ring-offset-0"
            />
          </FormControl>

          <span className="absolute inset-y-0 right-3 flex items-center">
            {field.value && <ClearButton onClick={handleClear} />}
          </span>
          <FormMessage className={"absolute left-0 top-full mt-1 text-xs text-red-600"} />
        </FormItem>
      );
    }}
  />
);
